module.exports = __webpack_public_path__ + "static/softonic-award-c3d893fe9967f0b5d6b1dfb0996ccc7b.png";